// Written by the edge gate (netlify/edge-functions/gate.ts) when it completes a Microsoft
// sign-in - the one gate cookie that is not HttpOnly. It holds the address the visitor signed
// in with, a username and never a credential. As a login hint it lets ssoSilent pick that
// account instead of failing when the browser holds several, so the user signs in once at the
// gate and not again. Absent wherever the gate is off, so callers must work unchanged without it
const HINT_COOKIE = 'hub_gate_user'

export const readGateLoginHint = (): string | undefined => {
  for (const part of document.cookie.split(';')) {
    const index = part.indexOf('=')
    if (index < 0 || part.slice(0, index).trim() !== HINT_COOKIE) continue
    try {
      return decodeURIComponent(part.slice(index + 1).trim()) || undefined
    } catch (e) {
      return undefined
    }
  }
  return undefined
}
